import React from 'react';
import { useIntl } from 'react-intl';

// stateless UI component; parent manages tab state and tracking

// Transparent buttons for both inactive and active; use the Succession text color for all actives
const TAB_STYLES = [
  { id: 'opportunity', labelKey: 'succession.explore_tabs.opportunity', active: 'bg-transparent border-succession-border text-blue-400', inactive: 'bg-transparent border-succession-border text-succession-text-secondary hover:bg-succession-hover-bg hover:border-succession-border-hover' },
  { id: 'growth', labelKey: 'succession.explore_tabs.growth', active: 'bg-transparent border-succession-border text-blue-400', inactive: 'bg-transparent border-succession-border text-succession-text-secondary hover:bg-succession-hover-bg hover:border-succession-border-hover' },
  { id: 'succession', labelKey: 'succession.explore_tabs.succession', active: 'bg-transparent border-succession-border text-blue-400', inactive: 'bg-transparent border-succession-border text-succession-text-secondary hover:bg-succession-hover-bg hover:border-succession-border-hover' },
  { id: 'learn', labelKey: 'succession.explore_tabs.learn', active: 'bg-transparent border-succession-border text-blue-400', inactive: 'bg-transparent border-succession-border text-succession-text-secondary hover:bg-succession-hover-bg hover:border-succession-border-hover' },
];

export const ExploreTabs = ({ activeTab, onTabChange, className = '' }) => {
  const intl = useIntl();
  return (
    <div className={`flex items-center gap-4 flex-wrap text-succession-text-primary ${className}`} role="tablist" aria-label={intl.formatMessage({ id: 'succession.explore_tabs.aria_label' })}>
      {TAB_STYLES.map((t) => {
        const isActive = t.id === activeTab;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={isActive}
            aria-controls={`panel-${t.id}`}
            id={`tab-${t.id}`}
            onClick={() => onTabChange && onTabChange(t.id)}
            className={`relative flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border ${isActive ? t.active : t.inactive}`}
          >
            {intl.formatMessage({ id: t.labelKey })}
          </button>
        );
      })}
    </div>
  );
};

export default ExploreTabs;




